import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stbyCurrencySymbol',
})
export class CurrencySymbolPipe implements PipeTransform {
    transform(): string {
        return '€';
    }
}
